module.exports = __webpack_public_path__ + "static/media/dropdown_icon.3ba7d9b7.svg";